<template>
    <v-dialog v-model="dialogIsOpen" max-width="320" :persistent="true">
        <v-card class="dialog-box home-form-container">
            <h2 class="rack-title">{{action === "add" ? `${$t('New')} ${objectType}` :`${$t('Edit')} ${objectType}`}}</h2>
            <div class="rack-form-item mb-4">
                <label class="mb-1">{{`${$t('Phase')} *`}}</label>
                <treeselect
                    v-model="object.status"
                    :options="phaseOption"
                    disableFuzzyMatching
                    class="rack-form-input-select"
                />
            </div>
            <div class="rack-label-input mb-4">
                <label class="mb-1">{{`${$tc('Label',1)} *`}}</label>
                <input
                    v-model="object.label"
                    type="text"
                />
            </div>
            <div class="rack-form-item mb-5">
                <label class="mb-1">{{`${$tc('MaterialReference',1)} *`}}</label>
                <treeselect
                    :disabled="action === 'edit'"
                    :options="objectType === 'rack' ? rackOptions : drawerOptions"
                    v-model="object.material_id"
                    disableFuzzyMatching
                    class="rack-form-input-select"
                />
            </div>
            <v-card-actions class="rack-form-buttons">
                <v-btn
                    @click="$emit('close-rack-form')"
                    :ripple="false"
                    class="secondary-button"
                    text
                >
                    {{ $t("Cancel") }}
                </v-btn>
                <v-btn
                    :disabled="isDisabled"
                    @click="saveObject"
                    :ripple="false"
                    class="main-button"
                    text
                >
                    {{action === "add" ? $t("Save") : $t("Edit")}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import InputField from "@/components/Home/Forms/_Molecules/InputField";
import _ from "lodash";
export default {
    name: "RackDrawerForm",
    components: {
        InputField
    },
    props: {
        dialogIsOpen: {
            type: Boolean,
            required: true
        },
        itemToEdit: {
            type: Object
        },
        objectType: {
            type: String
        },
        action: {
            type: String
        },
        rackOptions: {
            type: Array
        },
        drawerOptions: {
            type: Array
        }
    },
    mounted() {
        this.setEditData();
        this.getPhaseOption();
    },
    data() {
        return {
            object: {
                status: null,
                material_id: null,
                label: null
            },
            phaseOption: [],
        };
    },
    computed: {
        isDisabled(){
            return !(!!this.object.status && !!this.object.label && !!this.object.material_id);
        }
    },
    methods: {
        saveObject: _.debounce(function () {
            this.$emit(`${this.action}-${this.objectType}`, this.object);
        }, 100),
        setEditData(){
            if(this.action === "edit"){
                if(this.objectType === "rack"){
                    this.object.label = this.itemToEdit.ra_label;
                    this.object.material_id = this.itemToEdit.ra_material_id;
                    this.object.status = this.itemToEdit.ra_status;
                }else{
                    this.object.label = this.itemToEdit.data.dr_label;
                    this.object.material_id = this.itemToEdit.data.dr_material_id;
                    this.object.status = this.itemToEdit.data.dr_status;
                }
            }
        },
        getPhaseOption(){
            const projectPhases = this.$store.getters.optionLists_phase;
            projectPhases.forEach((phase)=>{
                this.phaseOption.push({
                    label: phase.client_label ? phase.client_label : phase.libelle,
                    id: phase.code
                });
            });
        },
    }
}
</script>

<style>
.rack-form-item, .rack-label-input{
    width: 100%;
    padding-left: 5px;
    font-family: 'Lato', sans-serif;
    text-align: left;
    font-size: 12px;
}
.rack-label-input{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.rack-label-input input {
    width: 100%;
    height: 32px;
    border: 1px solid black;
    border-radius: 5px;
    padding-left: 10px;
}
.rack-title{
    color: #42A1B6;
    text-align: start;
    padding-left: 5px;
    margin-bottom: 10px;
}
.input-field{
  padding: 4px 0px !important;
  padding-left: 5px !important;
}
.rack-form-input-select .vue-treeselect__control{
    border: 1px solid black;
    border-radius: 5px !important;
}

.v-dialog__content.v-dialog__content--active  .rack-form-item  .vue-treeselect__control:hover {
    border: 1px solid black !important;
}
.rack-form-buttons{
    padding-right: 0px !important;
}
.rack-form-input-select .vue-treeselect__menu-container .vue-treeselect__menu{
    max-height: 90px !important;
}
.v-dialog--active {
  overflow-y: visible !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/InsidePlan/forms/RackDrawerForm.vue